import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../../business-services/account.service';

const AccountTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblAccountDetails', route: 'account-details' },
  { id: 2, label: 'lblContacts', route: 'contact-details' }
]

@Component({
  selector: 'app-view-account',
  templateUrl: './view-account.component.html',
})
export class ViewAccountComponent implements OnInit {

  // accountId: number = 1;
  accountId: string;
  accountNo: string;
  accountName: string;
  customerId: string;
  selectedtab: number = 1;
  noOfTabLimit: number = 2;
  tabs: { id: number, label: string, route: string }[] = AccountTabs;

  constructor(private activeModal: NgbActiveModal,
    private accountService: AccountService) { }

  ngOnInit(): void {
    this.accountId = this.accountService.accountId;
    this.accountNo = this.accountService.accountNo;
    this.accountName = this.accountService.accountName;
    this.customerId = this.accountService.customerId;
  }

  OnClose() {
    this.activeModal.close({ success: false });
  }

  backToFirstTab() {
    this.selectedtab = 1;
  }

  tabSelected(id) {
    this.selectedtab = id;
  }
}
